function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  
    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }
  
    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  
    if (summary.closest('header-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
  });
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch (e) {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
  
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
  }
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }
  }
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  Shopify.bind = function (fn, scope) {
    return function () {
      return fn.apply(scope, arguments);
    }
  };
  
  Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  
  Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
  };
  
  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  
    this.initCountry();
    this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
  
    initProvince: function () {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
  
    countryHandler: function (e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex];
      var raw = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
  
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
  
        this.provinceContainer.style.display = "";
      }
    },
  
    clearOptions: function (selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
  
    setOptions: function (selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
  
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.has-submenu');
      const isOpen = detailsElement.hasAttribute('open');
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  
      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }
  
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          parentMenuElement && parentMenuElement.classList.add('submenu-open');
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
  
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.getElementById('shopify-section-header');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
      this.header.classList.add('menu-open');
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
  
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus) {
      super.closeMenuDrawer(event, elementToFocus);
      this.header.classList.remove('menu-open');
    }
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this, false)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
  
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent(focus = true) {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = true;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.dots = this.querySelector('.slider-counter--dots');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  
      // console.log('loaded')
  
  
  
  
      // click and drag functionality
      let mouseIsDown = false,
        sliderPosition = { left: 0, x: 0 };
      const sliderMouseDown = function (e) {
        sliderPosition = {
          // Get slider left
          left: this.scrollLeft,
          // Get the current mouse position
          x: e.clientX,
        };
        mouseIsDown = true;
        this.classList.add('dragging');
        this.addEventListener('mousemove', sliderDrag);
        this.addEventListener('mouseup', sliderMouseUp);
      };
      const sliderDrag = function (e) {
        if (mouseIsDown) {
          // How far the mouse has been moved
          const xMove = e.clientX - sliderPosition.x;
          // drag to this
          this.scrollLeft = sliderPosition.left - xMove;
        }
      };
      const sliderMouseUp = function () {
        mouseIsDown = false;
        this.classList.remove('dragging');
        this.removeEventListener('mousemove', sliderDrag);
        this.removeEventListener('mouseup', sliderMouseUp);
      };
      // Attach the handlers
      this.slider.addEventListener('mousedown', sliderMouseDown);
      this.slider.addEventListener('mouseleave', sliderMouseUp);
  
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      // this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
      this.totalPages = this.sliderItemsToShow.length;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      this.dots.innerHTML = '';
      for (let i = 0; i < this.totalPages; i++) {
        const dot = document.createElement("button");
        dot.innerHTML = "<span class='visually-hidden'>Slide " + (i + 1) + "</span>";
        dot.type = "button";
        dot.classList = "slider-counter--dot";
        this.dots.append(dot)
        dot.addEventListener('click', this.onButtonClick.bind(this));
      }
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
        var dotList = this.dots.querySelectorAll("button"),
          curPage = this.currentPage - 1;
        dotList.forEach(function (element, index) {
          if (index === curPage) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
        });
  
        this.sliderItems.forEach(function (element, index) {
          if (index === curPage) {
            element.classList.add('is-active');
          } else {
            element.classList.remove('is-active');
          }
        });
  
      }
  
      // console.log(this.currentPage)
  
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }
  
      if (!this.enableSliderLooping) {
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
  
      if (this.enableSliderLooping) {
  
  
        // if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        //   console.log('prev')
        //   console.log(this.sliderItemsToShow.length)
        //   this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        //     currentPage: this.sliderItemsToShow.length,
        //     currentElement: this.sliderItemsToShow[this.sliderItemsToShow.length]
        //   }}));
        // }
        // if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        //   console.log('next')
        //   this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        //     currentPage: 1,
        //     currentElement: this.sliderItemsToShow[1]
        //   }}));
        // }
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      const isDot = event.currentTarget.classList.contains('slider-counter--dot');
  
      // console.log(event.currentTarget.name)
  
      if (isDot) {
        const els = Array.prototype.slice.call(this.dots.querySelectorAll("button"), 0);
        const ind = els.indexOf(event.currentTarget);
        this.slideScrollPosition = ind * this.sliderItemOffset;
      } else {
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      }
  
      // console.log(this.slideScrollPosition)
  
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      console.log('loaded')
  
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!isFirstSlide && !isLastSlide) return;
  
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  class ProductGalleryComponent extends HTMLElement {
    constructor() {
      super();
      this.initMedia()
      this.mainCarousel;
      this.thumbCarousel;
    }
    initMedia() {
      // Desktop behavior
      if (window.innerWidth >= 989) {
        if ($('.thumbnail-gallery .gallery-cell.active').length > 4) {
          this.thumbCarousel = $('.thumbnail-gallery').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            slide: '.active',
            dots: false,
            vertical: true,
            focusOnSelect: true,
            centerMode: false
          });
          
          // Add click handler for thumbnails to change main image
          $('.thumbnail-gallery .gallery-cell.active').click(function (e) {
            e.preventDefault();
            var imgSrc = $(this).find('img').attr('src');
            var mainImg = $('.main-gallery .gallery-cell.active.is-selected').find('img');
            if (mainImg.length) {
              mainImg.attr('src', imgSrc);
            }
          });
        }
      } 
      // Mobile behavior remains the same
      else if (window.innerWidth < 989) {
        if ($('.thumbnail-gallery .gallery-cell.active').length > 4) {
          this.mainCarousel = $('.main-gallery').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            slide: '.active',
            asNavFor: '.thumbnail-gallery',
            responsive: [
              {
                breakpoint: 989,
                settings: {
                  fade: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  arrows: true,
                  prevArrow: '<button type="button" class="slider-button slider-button--prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
                  nextArrow: '<button type="button" class="slider-button slider-button--next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
                  dots: true,
                  autoplaySpeed: 2000,
                  appendArrows: $('.slider-buttons'),
                  appendDots: $('.slider-buttons'),
                  focusOnSelect: false,
                  infinite: true
                }
              }
            ]
          });
          this.thumbCarousel = $('.thumbnail-gallery').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            slide: '.active',
            asNavFor: '.main-gallery',
            dots: false,
            vertical: true,
            focusOnSelect: true,
            centerMode: false,
            responsive: [
              {
                breakpoint: 990,
                settings: {
                  vertical: false,
                }
              }
            ]
          });
        } else {
          this.mainCarousel = $('.main-gallery').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            slide: '.active',
            responsive: [
              {
                breakpoint: 989,
                settings: {
                  fade: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  centerMode: true,
                  arrows: true,
                  prevArrow: '<button type="button" class="slider-button slider-button--prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
                  nextArrow: '<button type="button" class="slider-button slider-button--next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
                  dots: true,
                  autoplaySpeed: 2000,
                  appendArrows: $('.slider-buttons'),
                  appendDots: $('.slider-buttons'),
                  focusOnSelect: false,
                  infinite: true
                }
              }
            ]
          });
          $('.thumbnail-gallery .gallery-cell.active').click(function (e) {
            e.preventDefault();
            var activeCell = $(this);
            var Gotoindex = $(this).index();
            $('.thumbnail-gallery .gallery-cell.active').each(function (index) {
              if (activeCell.index() == $(this).index()) {
                Gotoindex = index;
              }
            });
            $('.main-gallery').slick('slickGoTo', Gotoindex)
          })
        }
      }
    }

    updateMedia(currentVariant) {
      console.log(currentVariant);
      // Unslick existing sliders
      if (window.innerWidth < 989) {
        if (this.mainCarousel) {
          this.mainCarousel.slick('unslick');
        }
      }
      if (this.thumbCarousel) {
        this.thumbCarousel.slick('unslick');
      }
      
      var filterClass = 'variant--' + currentVariant.title.replace(' ', '-');
      console.log(filterClass)
      $('.main-gallery .gallery-cell').each(function () {
        $(this).removeClass('active');
        if ($(this).hasClass(filterClass) || $(this).hasClass('video') || $(this).hasClass('all')) {
          $(this).addClass('active');
        }
      })
      $('.thumbnail-gallery .gallery-cell').each(function () {
        $(this).removeClass('active');
        if ($(this).hasClass(filterClass) || $(this).hasClass('video') || $(this).hasClass('all')) {
          $(this).addClass('active');
        }
      })
      this.initMedia();
    }
  }
  
  class VariantSelects extends ProductGalleryComponent {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia(this.currentVariant);
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          if (source && destination) destination.innerHTML = source.innerHTML;
  
          const price = document.getElementById(`price-${this.dataset.section}`);
  
          if (price) price.classList.remove('visibility-hidden');
          this.toggleAddButton(!this.currentVariant.available, 'Notify Me');
        });
  
  
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
  
      if (disable) {
        addButton.classList.add('klaviyo-bis-trigger')
        if (text) addButtonText.textContent = text;
      } else {
        addButton.classList.remove('klaviyo-bis-trigger')
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  if (document.querySelector('variant-selects') == undefined && document.querySelector('variant-radios') == undefined) {
    customElements.define('product-gallery-component', ProductGalleryComponent);
  } else {
    customElements.define('variant-selects', VariantSelects);
  }
  
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
      // Sets the color name above the Swatches
      fieldsets.forEach(element => {
        var isColor = element.classList.contains('is-color');
        if (isColor) {
          var currentColor = Array.from(element.querySelectorAll('input')).find((radio) => radio.checked).value;
          element.querySelectorAll('.color-name')[0].innerText = currentColor;
        }
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
  
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
  
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
  
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
  
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }
  
  customElements.define('product-recommendations', ProductRecommendations);
  
  
  
  
  function watchForElement(el, method) {
    chkDelay = '200'; // Amount of time between Checks
    var chkExist = setInterval(function () {
      chkClass = $(el);
      if (chkClass.length) {
        // DO something
        clearInterval(chkExist);
        method(chkClass)
      }
    }, chkDelay);
  }
  
  
  
  
  function Modal(el) {
    el = el;
    act = 'active';
    actMod = 'modal-active';
    initMdl(el)
  
    function initMdl(el) {
      winWidth = $(window).width();
      thisEl = el;
      type = getDataName($(thisEl)).length ? getDataName($(thisEl)) : 'modal';
      thisMdl = getDataName($(thisEl)).length ? $('[data-modal="' + $(thisEl).data(type) + '"]') : $(thisEl);
      if (type == 'open' || type == 'modal') {
        if (!thisMdl.is('.' + act)) {
          showModal(thisMdl);
        } else {
          hideModal(thisMdl);
        }
      }
      if (type == 'close') {
        hideModal(thisMdl);
      }
    }
  
    function showModal(el) {
      var lastTop = $(window).scrollTop(),
        el = $(el),
        delay = 0;
      $('body').addClass(actMod).css({ top: -lastTop });
      if (el.is('[style*=display]')) {
        el[0].removeAttribute('style');
        delay = 100; // gives a moment for animation settings to take over
      }
      setTimeout(function () {
        el.addClass(act);
        el.find(':focusable').first().focus();
      }, delay)
    }
  
    function hideModal(el) {
      var lastTop = Math.abs(parseInt($('body').css('top'))),
        el = $(el);
      $('body').css({ top: 0 }).removeClass(actMod);
      window.scrollTo(0, lastTop);
      el.removeClass(act);
    }
  
    function getDataName(node) {
      var d = {},
        key = '',
        re_dataAttr = /^data\-(.+)$/;
      $.each(node.get(0).attributes, function (index, attr) {
        if (re_dataAttr.test(attr.nodeName)) {
          key = attr.nodeName.match(re_dataAttr)[1];
        }
      });
      return key;
    }
  }
  
  
  waitFor_jQuery(function () {
  
  
    jQuery.extend(jQuery.expr[':'], {
      focusable: function (el, index, selector) {
        return $(el).is('a, button, :input, label, [tabindex]');
      }
    });
  
  
    // Accordian
    $('#tabs-select').on('change', function () {
      var url = $(this).val(); // get selected value
      if (url) { // require a URL
        // window.location = url; // redirect
        $('a[href="' + url + '"]').trigger('click');
      }
      return false;
    });
  
    // sidebar links
    $('.accordion-section .sidebar-link').on('click  touch', function () {
      // body...
      $('.accordion-section .sidebar-link').removeClass('active');
      $(this).addClass('active');
    })
    // Accordian
    $(document).on('touch click', '.acc-btn', function () {
      var btn = '.acc-btn',
        $ths = $(this),
        animTime = 300,
        justClickedDelay = 500,
        justClicked = false,
        active = 'selected',
        cont = '.acc-content',
        par = '.acc-container',
        ttlTxt = 'h3',
        imgItm = '.img',
        $thsPar = $ths.closest(par),
        clckdIndx = $ths.closest('.site-footer').length == 0 ? $ths.index(btn) : 0, //must not have '- 1' for section style, if page style stops working a new solution is needed
        $cont = $ths.next(cont),
        inrChld = $cont.children(),
        inrChldHght = inrChld.outerHeight(),
        $thsTtl = $thsPar.find(ttlTxt).eq(clckdIndx),
        $thsImg = $thsPar.find(imgItm).eq(clckdIndx),
        isOpen = $thsTtl.hasClass(active),
        winWidth = $(window).width(),
        clearItem = $('#shopify-section-header'),
        actTab = $(ttlTxt + '.' + active),
        actTabTop = !!actTab ? '' : actTab[0].getBoundingClientRect().top + window.scrollY;
  
      // console.log(clckdIndx)
      // console.log($thsPar)
      // console.log($cont)
      if (!!clearItem && !!actTab) {
        actTabTop = actTabTop + clearItem.outerHeight(true) + 15;
      }
  
      if (!justClicked) {
        justClicked = true;
        if (isOpen) {
          removeClasses();
          openClose();
          // console.log('close')
        } else {
          // console.log('open')
          removeClasses();
          addClasses();
          openClose(true);
          // mobScroll();
        }
        setTimeout(function () {
          justClicked = false;
        }, justClickedDelay);
      }
  
      function mobScroll() {
        if (winWidth < 750) {
          setTimeout(function () {
            // console.log(openTabDist)
            $([document.documentElement, document.body]).animate({
              scrollTop: openTabDist
            }, animTime);
          }, animTime * 2.5);
        }
      }
  
      function removeClasses() {
        $thsPar.find(btn + ' ' + ttlTxt).removeClass(active);
        $thsPar.find(btn + ' ' + imgItm).removeClass(active);
      }
  
      function addClasses() {
        $thsTtl.addClass(active);
        $thsImg.addClass(active);
      }
  
      function zeroHght() {
        $thsPar.find(cont).stop().animate({ height: 0 }, animTime);
      }
  
      function setHght() {
        $thsPar.find(cont).eq(clckdIndx).stop().animate({ height: inrChldHght }, animTime);
      }
  
      function openClose(dir) {
        if (dir == 'open' || dir == true) {
          zeroHght()
          setHght()
        } else {
          setHght()
          zeroHght()
        }
      }
    });
  
  
  
    // on load
    thisHash = window.location.hash;
    clearThis = $('#shopify-section-header').height() + $('#shopify-section-announcement-bar').height() + 100;
  
    // removes hash from href
    // history.pushState(thisHash, '', window.location.pathname);
    if (thisHash.length > 0) {
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $(thisHash).offset().top - clearThis
        }, 1000);
      }, 200)
    }
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#recover"]')
      .not('[href="#login"]')
      .not('[href="#0"]')
      // .not('.recomProdAd')
      .click(function (event) {
  
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
  
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - clearThis - 100
            }, 1000, function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                console.log("asdfasdf")
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
  
  
    var actLogin = 'active';
    if (thisHash.length > 0 && thisHash == '#recover') {
      $('.' + actLogin).removeClass(actLogin);
      $(thisHash).addClass(actLogin);
    }
    $('[href="#recover"],[href="#login"]').click(function (e) {
      e.preventDefault()
      var tar = $(this).attr('href');
      $('.' + actLogin).removeClass(actLogin);
      $(tar).addClass(actLogin);
    })
  
    $('a')
      .not('#boldmetrics-ssc-activator')
      .not('.img-tab-link-2') // .not() ignores anchors with this class
      .not('[href*="tel:"]')
      .not('[href*="mailto:"]')
      .not('.product-single__thumbnail')
      .not('[href="#recover"]')
      .not('[href="#login"]')
      .not('[href="javascript:void(0);"]')
      .each(function () {
        var a = new RegExp('/' + window.location.host + '/');
        if (!a.test(this.href)) {
          $(this).click(function (event) {
            if (!$(this).is('#boldmetrics-ssc-activator')) {
              event.preventDefault();
              event.stopPropagation();
              window.open(this.href, '_blank');
            }
          });
        }
      });
  
  
    // show/hide back to top
    backToTop()
  
    $(document).scroll(function () {
      backToTop()
    });
    $(document).resize(function () {
      backToTop()
    });
  
    function backToTop() {
      var topBtn = $('.back-to-top'),
        act = 'show-top',
        fromTop = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop,
        minDist = window.innerHeight * 1.3;
      if (fromTop > minDist) {
        topBtn.addClass(act)
      } else {
        topBtn.removeClass(act)
      }
    }
  
  
    $('.js-filters-toggle').click(function (e) {
      $('html').toggleClass('filters-is-open');
      e.preventDefault();
    });
  
  
    $(document).ready(function () {
      $('.modal-action').on('click touch', function (e) {
        e.preventDefault();
        Modal($(this));
        // console.log($(this))
  
        var vid = $(this).closest('.video-modal').find('iframe');
        if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
          var vidSrc = vid.attr('src');
          // console.log(vidSrc)
          vid.attr('src', vidSrc);
        }
      })
  
  
      $('.btn-modal').on('click touch', function () {
  
        var thsId = $(this).attr('href');
  
        Modal($(thsId));
        // console.log($(thsId))
  
        var vid = $(thsId).find('iframe');
        if (vid.length > 0 && ($(this).is('.close-modal') || $(this).is('.bg_close'))) {
          var vidSrc = vid.attr('src');
          // console.log(vidSrc)
          vid.attr('src', vidSrc);
        }
      })
    })
  
    videoRatio()
  
    function videoRatio() {
      var vid = $('.video-ratio:not(.for-modal) iframe, .video-ratio:not(.for-modal) video');
  
      initRatio();
      $(window).resize(function () {
        initRatio();
      })
  
      function initRatio() {
        var winWdth = $(window).width(),
          ratio = 0.56;
  
        if (vid.length) {
          vid.each(function () {
            var thsVid = $(this);
  
            if (typeof thsVid.data('video-ratio') !== 'undefined') {
              var ratio = thsVid.data('video-ratio');
            }
            var thsVidPar = thsVid.closest('div'),
              thsVidParHght = thsVidPar.outerHeight(true),
              cssHght = thsVidParHght,
              cssWdth = cssHght / ratio;
  
            if (cssWdth < winWdth) {
              var cssWdth = winWdth,
                cssHght = cssWdth * ratio;
            }
  
            thsVid.attr('style', 'width: ' + cssWdth + 'px !important;height: ' + cssHght + 'px !important;')
  
          })
        }
      }
    }
  
  
    // New Navigation 
    $(document).ready(function () {
      var mega, drp, prvFxdHdrHght, prevDistFromTop;
      var winWdth = $(window).width(),
        distFromTop = document.documentElement.scrollTop,
        prevdistFromTop = distFromTop,
        mobInit = 990,
        isDesk = winWdth >= mobInit,
        justClicked = false,
        fxdHdr = 'header.header',
        fxdHdrHght = $(fxdHdr).height(),
        mnCntnt = '#MainContent',
        lnk = '.nav-item',
        hasDropDown = '.main-link--with-dropdown',
        inrLnk = '.dropdown-link',
        drpDwn = '.dropdown-list',
        nulLnk = 'a[href="#"]',
        megaMenu = '.mega-pane',
        megaDta = 'megamenu',
        drpActive = 'active',
        bdyLockCls = 'locked',
        inr = 'inner-',
        otrItmDta = 'nav-item',
        inrItmDta = inr + otrItmDta,
        otrDrpDta = 'dropdown',
        inrDrpDta = inr + otrDrpDta,
        mobNav = '.mobile-nav',
        drpDwnStl = '.use-dropdown',
        sideStl = '.side-panel',
        openCloseMobNav = '.menu-btn,.close-nav',
        mobNavOpen = 'mobile-nav-open',
        navOpen = 'mobile-nav--open',
        navClose = 'mobile-nav--close',
        mobNavBG = '.mobile-nav-background-close',
        moveAside = '.move-aside',
        mobDrpTggl = '.menu-toggle',
        mobBckTggl = '.reverse',
        lvlOne = 'level-one',
        lvlTwo = 'level-two';
  
      function clickPolice(justClicked) {
        // console.log('clickPolice')
        // justClicked = true;
        // setTimeout(function() { justClicked = false;
        //   console.log(justClicked) }, 700);
      }
  
      var vars = mobInit, lnk, inrLnk, megaMenu, drpDwn, mobDrpTggl, drpDwnStl, sideStl, mobNavBG, fxdHdrHght, prvFxdHdrHght, mnCntnt;
  
      initNav(vars)
      setTimeout(function () {
        // body...
        initNav(vars)
      }, 1000)
      $(window).resize(function () {
        initNav(vars)
      })
      $(window).scroll(function () {
        if (!$('body').has(bdyLockCls)) {
          initNav(vars)
          closeMega()
        }
      })
  
      function initNav(vars) {
        var winWdth = $(window).width(),
          fxdHdrHght = $(fxdHdr).height(),
          isDesk = winWdth >= mobInit;
  
        // This is needed to prevent mobile menu from being buggy. 
        $(lnk + ',' + inrLnk + ',' + megaMenu + ',' + drpDwn + ',' + mobDrpTggl + ',' + lnk + ' ' + nulLnk + ',' + inrLnk + ' ' + nulLnk + ',' + openCloseMobNav + ',' + mobNavBG).off();
  
  
        if (prvFxdHdrHght != fxdHdrHght) {
          // $(megaMenu).css({
          //   top: fxdHdrHght
          // });
          var prvFxdHdrHght = fxdHdrHght;
        }
        if (isDesk == true) {
          // $(lnk + ',' + inrLnk).off().on('mouseover mouseleave focusin focusout', function(e) {
          $(lnk + '.main-link--with-dropdown,' + inrLnk).off().on('touch click', function (e) {
            if (!justClicked && isDesk) {
              clickPolice()
              // console.log(this)
  
              openLinks($(this))
  
              // if (e.type == 'mouseover' || e.type == 'focusin') {
              // }
              // if (e.type == 'mouseleave') {
              //   // closeLinks($(this))
              // }
              // if (e.type == 'focusout') {
              //   // fcsChkr($(this))
              // }
            }
          })
          $(megaMenu + ',' + drpDwn).off().on('mouseleave focusout', function (e) {
            if (!justClicked && isDesk) {
              clickPolice()
              // console.log(this)
  
              if (e.type == 'mouseleave' && $(this).is(megaMenu)) {
                // closeMega($(this))
              }
              if (e.type == 'focusout' && $(this).is(megaMenu)) {
                // fcsChkr($(this))
              }
              if (e.type == 'mouseleave' && ($(this).is(drpDwn) || $(sideStl).length > 0)) {
                // closeLinks($(this))
              }
            }
          })
          $(openCloseMobNav + ',' + mobNavBG).off().on('touch click', function (e) {
            closeLinks($(this))
          })
        } else {
          $(mobDrpTggl + ',' + lnk + ' ' + nulLnk + ',' + inrLnk + ' ' + nulLnk).off().on('touch click', function (e) {
            if (!justClicked && !isDesk) {
              clickPolice()
  
  
              // If arrow click
              if ($(this).is(mobDrpTggl)) {
                ths = $(this);
              }
              // if null link ('#' as href)
              if ($(this).is(nulLnk)) {
                e.preventDefault();
                ths = $(this).parent().children(mobDrpTggl);
              }
              openMobLnk(ths)
  
  
            }
          })
          $(openCloseMobNav + ',' + mobNavBG).off().on('touch click', function (e) {
            e.preventDefault();
            if (!justClicked && !isDesk) {
              clickPolice()
  
              toggleMobNav()
            }
          })
        }
      }
  
      function openLinks(el) {
        var $thsLnk = $(el),
          isAct = $thsLnk.is('.' + drpActive),
          isSideStyle = $(sideStl).length > 0,
          isInsideSidePanel = $thsLnk.closest(sideStl).length > 0,
          otrData = $thsLnk.data(otrItmDta),
          inrData = $thsLnk.data(inrItmDta);
        if (!isSideStyle) {
          if (!!otrData || !!inrData) {
            closeLinks($thsLnk)
          }
          if (!isAct) {
            $thsLnk.addClass(drpActive);
            // Activate Megamenu
            var mega = $('[data-' + megaDta + '="' + otrData + '"]');
            if (!!mega) {
              fxdHdrHght = $(fxdHdr).height();
              mega
                // .css({top: fxdHdrHght})
                .addClass(drpActive);
            }
          }
        } else {
          if (isInsideSidePanel) {
            $('.side-panel .nav-item').removeClass(drpActive);
            $thsLnk.addClass(drpActive);
          } else {
            var sideLink = $('.side-panel [data-' + otrItmDta + '="' + otrData + '"]');
            // console.log(sideLink)
            $('.side-panel .nav-item').removeClass(drpActive);
            sideLink.addClass(drpActive);
            lockBody()
            $(sideStl).addClass(drpActive);
            $('.side-panel' + mobNavBG).addClass(drpActive);
          }
        }
      }
  
      function closeLinks(el) {
        var $thsLnk = $(el),
          isSideStyle = $(sideStl).length > 0,
          otrData = $thsLnk.data(otrItmDta),
          inrAct = $thsLnk.is('.' + drpActive),
          megaAct = $('[data-' + megaDta + '="' + otrData + '"]').is('.' + drpActive);
        if (!isSideStyle) {
          if (!megaAct && !inrAct) {
            $(drpDwn + ',' + megaMenu + ',' + lnk + ',' + inrLnk).removeClass(drpActive);
          }
        } else {
          unlockBody()
          $('.side-panel .nav-item').removeClass(drpActive);
          $(sideStl).removeClass(drpActive);
          $('.side-panel' + mobNavBG).removeClass(drpActive);
  
        }
  
      }
  
      function closeMega(el) {
        $(drpDwn + ',' + megaMenu).removeClass(drpActive);
        $(lnk).removeClass(drpActive);
      }
  
      function toggleMobNav(el) {
        var isAct = $(mobNav).is('.' + drpActive);
        if (!isAct) {
          lockBody()
          var distFromTop = document.documentElement.scrollTop;
          // make nav active
          $(mobNav + ',' + mobNavBG).addClass(drpActive);
          $(openCloseMobNav).addClass(navClose).removeClass(navOpen);
          // $('body').css('top', -(distFromTop) + 'px').addClass(bdyLockCls);
          $(fxdHdr).addClass(mobNavOpen);
        } else {
          unlockBody()
  
          $(openCloseMobNav).removeClass(navClose).addClass(navOpen);
          // remove active from menu and bg-overlay/close
          $(mobNav + ',' + mobNavBG).removeClass(drpActive);
          // remove all active classes to reset menu
          $(mobNav + ' .' + drpActive).removeClass(drpActive);
          // remove level classes from the move aside element
          $(moveAside).removeClass(lvlOne).removeClass(lvlTwo);
          // $('body').removeClass(bdyLockCls);
          // $(window).scrollTop(prevDistFromTop);
          $(fxdHdr).removeClass(mobNavOpen);
        }
        prevDistFromTop = distFromTop;
      }
  
      function openMobLnk(el) {
        var $thsLnk = $(el),
          isDrpTggl = $thsLnk.is(mobDrpTggl),
          isBckTggl = $thsLnk.is(mobBckTggl),
          $thsPar = $thsLnk.parent(),
          isDropStyle = $thsLnk.closest(drpDwnStl).length > 0,
          isAct = $thsPar.is('.' + drpActive),
          moveLvlOne = $(moveAside).is('.' + lvlOne),
          moveLvlTwo = $(moveAside).is('.' + lvlTwo);
  
        // console.log($thsPar)
        // Move to Second Level
        if (!moveLvlOne && $thsPar.is(lnk) && !isDropStyle) {
          remActive($thsPar)
          addActive($thsPar)
          togLvl(moveAside, lvlOne)
        }
        // Move to Third level
        if (!moveLvlTwo && $thsPar.is(inrLnk) && !isDropStyle) {
          remActive($thsPar)
          addActive($thsPar)
          togLvl(moveAside, lvlTwo)
        }
        // Move back to Second level
        if (moveLvlTwo && moveLvlOne && isBckTggl && !isDropStyle) {
          togLvl(moveAside, lvlTwo)
          remActive($thsPar)
        }
        // Move back to First level
        else if (moveLvlOne && isBckTggl && !isDropStyle) {
          togLvl(moveAside, lvlOne)
          remActive($thsPar)
        }
  
        // Drop Style
        if (isDropStyle) {
          if (isAct) {
            closeHeights($thsPar)
          } else {
            // console.log(0)
            if ($thsPar.is(lnk)) {
              // console.log(1)
              $(lnk + ',' + inrLnk).each(function () {
                closeHeights($(this))
              })
            }
            if ($thsPar.is(inrLnk)) {
              // console.log(2)
              $(inrLnk).each(function () {
                closeHeights($(this))
              })
            }
            openHeight($thsPar)
          }
        }
  
  
        function closeHeights(el) {
          var el = el;
          //  $inrList = el.children(drpDwn,inrDrpDwn),
          //  opnHght = !!$inrList ? null : $inrList[0].scrollHeight;
          // if ( opnHght != null ) {
          //  console.log(1,el,opnHght)
          //  $inrList.css('max-height',opnHght)
          //  $inrList.css('max-height','0px')
          // //   .animate({
          // //     maxHeight: '0px'
          // //   },200)
          // //   // .css('max-height','0px')
          // }
          el.removeClass(drpActive)
        }
  
        function openHeight(el) {
          var el = el;
          //  $inrList = el.children(drpDwn,inrDrpDwn),
          //  opnHght = !!$inrList ? null : $inrList[0].scrollHeight;
          // if ( opnHght != null ) {
          //  console.log(2,el,opnHght)
          //  $inrList.css('max-height',opnHght)
          //  setTimeout(function () {
          //    $inrList.css('max-height','100%')
          //  },500)
          // }
          el.addClass(drpActive)
        }
  
        function remActive(el) {
          setTimeout(function () {
            $thsPar.parent().children().removeClass(drpActive)
          }, 200)
        }
  
        function addActive(el) {
          setTimeout(function () {
            $thsPar.addClass(drpActive);
          }, 200)
        }
  
        function togLvl(el, cls) {
          setTimeout(function () {
            if ($(el).is('.' + cls)) {
              $(el).removeClass(cls)
            } else {
              $(el).addClass(cls);
            }
          }, 200)
        }
      }
  
      function lockBody() {
        var lastTop = $(window).scrollTop();
        var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        $('body').addClass(bdyLockCls).css({ top: -lastTop });
        if (isIOS) {
          var hght = window.innerHeight - 1;
          // console.log(hght)
          // console.log(hght+1)
          $('body').css({ height: hght });
        }
      }
      function unlockBody(el) {
        var lastTop = Math.abs(parseInt($('body').css('top')));
        var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        $('body').css({ top: 0 }).removeClass(bdyLockCls);
        window.scrollTo(0, lastTop);
        if (isIOS) {
          $('body')[0].style.removeProperty('height');
        }
      }
  
      function fcsChkr(el) {
        var $thsLnk = $(el);
        checker = setTimeout(function () {
          if (!$thsLnk.find(':focus').length) {
            closeLinks($thsLnk);
          }
        }, 0);
        clearTimeout(checker)
      }
    });
  
  
    $(document).ready(function () {
      if ($('body').hasClass('template--product')) {
        var initTopPosition = $('.template--product .product__info-wrapper .product-form__buttons').offset().top;
        // console.log(initTopPosition);
        $(window).scroll(function () {
          // console.log($(window).scrollTop(),initTopPosition);
          if ($(window).scrollTop() > initTopPosition)
            $('.template--product .product__info-wrapper .product-form__buttons').addClass("sticky");
          else
            $('.template--product .product__info-wrapper .product-form__buttons').removeClass("sticky");
        });
      }
    });
  
  
  
  
  
  
    // var elev_category = '';
    // var elev_format = '';
    // var elev_benefit = '';
  
    // var stepsSlider = {
    //   autoplay: false,
    //   dots: false,
    //   arrows: true,
    //   slidesToShow: 4,
    //   rows: 0, 
    //   infinite: false,
    //   responsive: [
    //     {
    //       breakpoint: 990,
    //       settings: {
    //         slidesToShow: 3
    //       }
    //     },
    //     {
    //       breakpoint: 750,
    //       settings: {
    //         slidesToShow: 2
    //       }
    //     },
    //     {
    //       breakpoint: 400,
    //       settings: {
    //         slidesToShow: 1
    //       }
    //     }
    //   ]
    // }
  
  
  
  
  
  
  
  
    // // Product-grid-item quick buy controls
    // var prdItmCls = '.card-wrapper',
    //   radioSubs = '.rc_radio__autodeliver',
    //   radioNorm = '.rc_radio__onetime',
    //   prdItmOpenFormCls = 'open',
    //   prdItmOpenSubsCls = 'open-subscription';
    // // Hide form when clicked outside
    // $(document).click(function(event) {
    //   var $target = $(event.target);
    //   // check if clicking outside product item and if product item is open
    //   if (!$target.closest(prdItmCls).length && $(prdItmCls).is('.' + prdItmOpenFormCls)) {
    //     $(prdItmCls).each(function(argument) {
    //       // remove classes
    //       $(this).removeClass(prdItmOpenFormCls).removeClass(prdItmOpenSubsCls);
    //       // if subscription then toggle the radio buttons
    //       if ($(this).is('.' + prdItmOpenSubsCls)) {
    //         toggleRadios($(this))
    //       }
    //     })
    //   }
    // });
    // // Open Normal Product Form
    // $(document).on('click touch', '.quick-add-button,.subscription-button', function(e) {
    //   e.preventDefault();
    //   // get this product item container
    //   var prodItem = $(this).closest(prdItmCls);
    //   // close other quick buys
    //   $(prdItmCls).not(prodItem).removeClass(prdItmOpenFormCls).removeClass(prdItmOpenSubsCls);
    //   // check if normal
  
  
    //   if ($(this).is('.quick-add-button')) {
    //     // open this quickbuy
    //     if (prodItem.is('.'+prdItmOpenFormCls)) {
    //       prodItem.removeClass(prdItmOpenFormCls).removeClass(prdItmOpenSubsCls);
    //     } else {
    //       prodItem.addClass(prdItmOpenFormCls).removeClass(prdItmOpenSubsCls);
    //     }
    //     $(this).parents(".quick-buy-container").find("input[name='product_type']").val("product");
    //     $(this).parents(".quick-buy-container").find("input[name='purchase_type'][value='onetime']").prop('checked', true);
    //   }
    //   // check if subscription
    //   if ($(this).is('.subscription-button')) {
    //     // open subscription
    //     if (prodItem.is('.'+prdItmOpenSubsCls)) {
    //       prodItem.removeClass(prdItmOpenSubsCls).removeClass(prdItmOpenFormCls);
    //     } else {
    //       prodItem.addClass(prdItmOpenSubsCls).removeClass(prdItmOpenFormCls);
    //     }
    //     // toggle radio buttons
    //     toggleRadios(prodItem)
    //     $(this).parents(".quick-buy-container").find("input[name='product_type']").val("subscription");
    //     $(this).parents(".quick-buy-container").find("input[name='purchase_type'][value='autodeliver']").prop('checked', true);
    //   }
    //   // console.log( $(this).parents(".quick-buy-container").find("input[name='product_type']").val());
    //   $(this).parents(".quick-buy-container").find("input[name='purchase_type']").trigger("change");
  
    // });
  
    // function toggleRadios(el) {
    //   var prodSubs = el.find(radioSubs),
    //     prodNorm = el.find(radioNorm);
  
    //   // console.log(prodNorm)
    //   // console.log(prodSubs)
  
    //   el.hasClass(prdItmOpenSubsCls) ? prodSubs.prop('checked', true) : prodSubs.prop('checked', false);
    //   el.hasClass(prdItmOpenSubsCls) ? prodNorm.prop('checked', false) : prodNorm.prop('checked', true);
    // }
  
  
  
    // $('.template--page-contact .Button--custom.btn-1').click(function (){
    //   $zopim.livechat.window.show();
    // })
  
  
  
  
    function move(el, moveEl, beforeAfter) {
      el = el;
      moveEl = moveEl;
      if (beforeAfter == 'before') {
        $(el).insertBefore(moveEl)
      } else if (beforeAfter == 'after') {
        $(el).insertAfter(moveEl)
      } else {
        $(el).appendTo(moveEl)
      }
    }
  
    // var selects = $('variant-radios'), 
    //     selectSiblings = selects.parent().children(),
    //     selectPosition = selects.index() - 1;
    // $('.rc_label__onetime,.rc_label__autodeliver').on('click touch',function () {
    //   var button = $(this);
    //   if ( button.is('.rc_label__onetime') ) {
    //     move(selects,button,'after')
    //   } else {
    //     move(selects,selectSiblings.eq(selectPosition),'after')
    //   }
    // });
  
  
  });
  
  // place at bottom of main js file
  var themeJSisLoaded = true;